"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hamburger = function Hamburger(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M18.75 11.9792H6.24999C6.11186 11.9792 5.97938 12.0341 5.88171 12.1318C5.78403 12.2295 5.72916 12.3619 5.72916 12.5001C5.72916 12.6382 5.78403 12.7707 5.88171 12.8684C5.97938 12.966 6.11186 13.0209 6.24999 13.0209H18.75C18.8881 13.0209 19.0206 12.966 19.1183 12.8684C19.2159 12.7707 19.2708 12.6382 19.2708 12.5001C19.2708 12.3619 19.2159 12.2295 19.1183 12.1318C19.0206 12.0341 18.8881 11.9792 18.75 11.9792Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18.75 7.8125H6.24999C6.11186 7.8125 5.97938 7.86737 5.88171 7.96505C5.78403 8.06272 5.72916 8.1952 5.72916 8.33333C5.72916 8.47147 5.78403 8.60394 5.88171 8.70162C5.97938 8.79929 6.11186 8.85417 6.24999 8.85417H18.75C18.8881 8.85417 19.0206 8.79929 19.1183 8.70162C19.2159 8.60394 19.2708 8.47147 19.2708 8.33333C19.2708 8.1952 19.2159 8.06272 19.1183 7.96505C19.0206 7.86737 18.8881 7.8125 18.75 7.8125Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18.75 16.1458H6.24999C6.11186 16.1458 5.97938 16.2006 5.88171 16.2983C5.78403 16.396 5.72916 16.5285 5.72916 16.6666C5.72916 16.8047 5.78403 16.9372 5.88171 17.0349C5.97938 17.1325 6.11186 17.1874 6.24999 17.1874H18.75C18.8881 17.1874 19.0206 17.1325 19.1183 17.0349C19.2159 16.9372 19.2708 16.8047 19.2708 16.6666C19.2708 16.5285 19.2159 16.396 19.1183 16.2983C19.0206 16.2006 18.8881 16.1458 18.75 16.1458Z",
    fill: props.foregroundColor
  }));
};

Hamburger.defaultProps = {
  altText: "Hamburger",
  foregroundColor: "#2D5AB4"
};
Hamburger.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Hamburger;
exports.default = _default;